/* eslint-disable react/jsx-filename-extension, max-len */
import getClientNoFeedbackData from './getClientNoFeedbackData';

const getClientNoFeedbackOneWeekData = (row) => ({
  ...getClientNoFeedbackData(row),
  text: 'No email communication since one week',
});

export default getClientNoFeedbackOneWeekData;
